import EssealPhoneInput from "@/components/EssealPhoneInput";
import { ResourceMetaCreate } from "@/graphql/generated/graphql";
import { TextField } from "@mui/material";
import { Grid } from "@mui/system";
import type { ResourceMetaChangeHandler } from "./types";

type HumanResourceFieldsProps = {
  resourceMeta: ResourceMetaCreate;
  onChange: ResourceMetaChangeHandler;
};

const HumanResourceFields: React.FC<HumanResourceFieldsProps> = ({ onChange, resourceMeta }) => {
  return (
    <>
      <Grid container size={12} p={2}>
        <TextField
          fullWidth
          id="email"
          label="Email Address"
          name="email"
          autoComplete="email"
          value={resourceMeta?.email || ""}
          onChange={(e) => onChange("email", e.target.value)}
        />
      </Grid>
      <Grid container size={12} p={2}>
        <EssealPhoneInput
          id="phone"
          label="Phone"
          name="phone"
          value={resourceMeta?.primaryPhone || ""}
          onChange={(e164) => onChange("primaryPhone", e164)}
          defaultCountry="GB"
          size="lg"
          style={{ width: "100%" }}
        />
      </Grid>
      <Grid container size={12} p={2}>
        <TextField
          label="Bio"
          variant="outlined"
          multiline
          rows={5}
          fullWidth
          value={resourceMeta?.bio || ""}
          onChange={(e) => onChange("bio", e.target.value)}
        />
      </Grid>
    </>
  );
};

export default HumanResourceFields;
